import { takeLatest, put, call, select } from 'redux-saga/effects';
import { RECOVERY_PASSWORD_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { authAction, recoveryPasswordAction } from "../actions";
import { RECOVERY_PASSWORD_FORM_INITIAL } from "../initialStateConstants";

const request = data => {
    return fetch(`${ url }/recovery_password`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRecoveryPassword(args) {
    const auth_form = yield select(state => state.auth_form);
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('email', args.data?.email);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            // Закрываем форму восстановления пароля
            yield put(recoveryPasswordAction(RECOVERY_PASSWORD_FORM_INITIAL));
            // Открываем форму регистрации
            yield put(authAction({
                ...auth_form,
                open: true
            }));

            toast.success(response.message);
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherRecoveryPassword() {
    yield takeLatest(RECOVERY_PASSWORD_SAGA, workerRecoveryPassword);
}